import { Button, Modal } from "react-bootstrap";
import Select from "react-select";
import { customStyle } from "../../../../shared";
import {
  brandConfigurationLabels,
  BUTTON_TEXT,
  modalSize,
} from "../../constants";

function AddBrandConfigurationModal(props) {
  const {
    show,
    onClose,
    brandFilterOptions,
    selectedBrand,
    onBrandChange,
    onGenerate,
    isLoading,
  } = props;

  return (
    <Modal
      show={show}
      onHide={onClose}
      size={modalSize.MODAL_SIZE_MEDIUM}
      backdrop="static"
      animation={true}
      className="react-survey-modal"
    >
      <div className="confirm-popup">
        <Modal.Header closeButton>
          <Modal.Title>{brandConfigurationLabels.ADD_TITLE}</Modal.Title>
        </Modal.Header>
      </div>
      <Modal.Body className="pb-15">
        <div className="mb-3">
          <label htmlFor="brand-select" className="form-label fw-bold">
            {brandConfigurationLabels.SELECT_BRAND}
          </label>
          <Select
            inputId="brand-select"
            name="brand"
            options={brandFilterOptions}
            getOptionValue={(option) => option.value}
            getOptionLabel={(option) => option.name}
            value={selectedBrand || null}
            placeholder={brandConfigurationLabels.SELECT_BRAND_PLACEHOLDER}
            components={{
              IndicatorSeparator: () => null,
            }}
            isSearchable={true}
            styles={customStyle}
            isMulti={false}
            onChange={onBrandChange}
          />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="primary"
          onClick={onGenerate}
          disabled={!selectedBrand || isLoading}
        >
          {isLoading ? BUTTON_TEXT.GENERATING : BUTTON_TEXT.GENERATE}
        </Button>
        <Button variant="secondary" onClick={onClose} disabled={isLoading}>
          {BUTTON_TEXT.CLOSE}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default AddBrandConfigurationModal;
